import {all, call, fork, put, takeEvery} from "redux-saga/effects";

import {FORGET_PASSWORD} from "./actionTypes";
import {userForgetPasswordError, userForgetPasswordSuccess} from "./actions";
import {resetPassword} from "../../../helpers/auth";

function* forgetUser({payload: {user, history}}) {
    try {
        const response = yield call(resetPassword, user);
        yield put(userForgetPasswordSuccess());
        localStorage.removeItem("authUser");
        window.location = "/login?error=new-password";
    } catch (error) {
        console.error(error);
        yield put(userForgetPasswordError(error));
    }
}

export function* watchUserPasswordForget() {
    yield takeEvery(FORGET_PASSWORD, forgetUser);
}

function* forgetPasswordSaga() {
    yield all([fork(watchUserPasswordForget)]);
}

export default forgetPasswordSaga;
